module.exports = __webpack_public_path__ + "static/container-wide-2ab591fcc9398c600f58ef7e836b070f.jpg";